import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { generateCert, getFacilitiyByIdV2, sendCert } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function SendCertificate({ open, title, onClose, report }) {
  const [sending, setSending] = useState(false);
  const [facility, setFacility] = useState();
  const [facilityLoading, setFacilityLoading] = useState(true);
  const [receipients, setReceipients] = useState([]);

  useEffect(() => {
    fetchFacility();
  }, []);

  useEffect(() => {
    if (facility) {
      getCertReceipients(facility?.facilityConsultant, facility?.facilityPersonel);
    }
  }, [facility]);

  const fetchFacility = () => {
    getFacilitiyByIdV2(report?.facilityId)
      .then((response) => {
        const responseData = response?.result?.data;
        setFacility(responseData);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setFacilityLoading(false));
  };

  const getCertReceipients = (consultants, personnels) => {
    const invoiceReceipients = [];

    consultants?.map((item) => {
      invoiceReceipients.push(item?.email);
    });

    personnels?.map((item) => {
      const canRecieveInvoice = item?.receiveCertEmail === 'true';
      if (canRecieveInvoice) {
        invoiceReceipients.push(item?.email);
      }
    });

    setReceipients(invoiceReceipients);
  };

  const handleResend = async () => {
    setSending(true);

    try {
      const res = await sendCert(report?.reportId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '1rem' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          {title}
        </DialogTitle>
        <Typography sx={{ marginLeft: 'auto', padding: '0 1rem' }}>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Typography>
      </Box>
      <DialogContent>
        <Alert severity="info">
          Sending certificate for {report?.reportTitle} to {report?.facility}
        </Alert>
        <br />
        <Typography>{`Certificate is a proof that the facility has complemented the payment of QAQC for the designated quarter of the year`}</Typography>
        <br />
        <Box>
          {facilityLoading ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CircularProgress size={20} />{' '}
              <Typography variant="body2" color="text.secondary">
                Fetching cerificate receipients
              </Typography>
            </Stack>
          ) : (
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ padding: '0 0 0.5rem 0' }}>
                Certificate receipients:
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                {receipients?.map((x) => (
                  <Chip label={x} />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem 2rem 1.5rem' }}>
        <Button
          type="button"
          size="medium"
          variant="contained"
          sx={{ textTransform: 'none', borderRadius: '30px', width: '100px' }}
          onClick={handleResend}
          startIcon={sending && <CircularProgress size={20} />}
          disabled={sending}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
